import { LocalizationProvider, TabContext, TabList, TabPanel } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { Box, Card, Grid, Tab, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useState } from 'react';
import BookingInformation from './BookingInformation';
import ContainerInformation from './ContainerInformation';
import api from '../../../../components/services/api'
import { useParams } from 'react-router';

export default function ViewCargoTracking() {
  const {id} = useParams()
  const [value, setValue] = useState("1");
  const [data, setData] = useState(null)
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
 
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Cargo Tracking
              </Typography>
              {/* <Typography className="textcolorgreen">
                
              </Typography> */}
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              marginBottom: "10px",
              width: 200,
              flexDirection: "row",
            }}
          >
            <Typography className="textcolorBule">Planner</Typography>
            <Typography>
              <span>&nbsp;/ CargoTracking</span>
            </Typography>
          </Box>
        </div>

        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginTop: "10px",
            }}
          >
            <TabList
              variant="scrollable"
              scrollButtons="auto"
              onChange={handleChangeTab}
              TabIndicatorProps={{
                style: { backgroundColor: "transparent" },
              }}
              sx={{
                overflow: "visible",
                "& .MuiTabs-scroller": { overflow: "visible !important" },
              }}
            >
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                  overflow: "visible",
                  "& .MuiTabs-scroller": { overflow: "visible !important" },
                }}
                label={
                  // <Badge badgeContent={4} color="error" sx={{ "& .MuiBadge-badge": { top: '-10px' } }}>
                  // <Typography>BOOKING INFORMATION</Typography>
                  // </Badge>
                  "Booking Information"
                }
                value="1"
              />

              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#80C340",
                    color: "white",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  },
                }}
                label="Container Information"
                value="2"
              />
            
            </TabList>
          </Box>
          <TabPanel value="1">
            <BookingInformation/>
          </TabPanel>
          <TabPanel value="2">
            <ContainerInformation/>
          </TabPanel>
        </TabContext>
      </Card>
    </LocalizationProvider>
  )
}
